/*
 * @Author: Json Chen
 * @Date: 2021-07-13 15:52:44
 * @LastEditTime: 2021-07-13 19:28:17
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Hooks/useWareHouseList.ts
 */
import { useEffect, useState } from 'react';
import { useRequest } from 'ahooks';
import { getWareHouseLocations } from '@/src/request/settings/logistics/wareHouseLocation';

const useWareHouseList = () => {
  const [warehouseList, setWarehouseList] = useState([]);

  const { loading: loading, run: _getWareHouseLocations } = useRequest(
    getWareHouseLocations,
    {
      manual: true,
      onSuccess(result) {
        setWarehouseList(result);
      },
    },
  );

  useEffect(() => {
    _getWareHouseLocations();
  }, []);

  return {
    loading,
    warehouseList,
    getWareHouseList: _getWareHouseLocations,
  };
};

export default useWareHouseList;
